/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixHostConfiguration extends models.ZabbixConfigurationBase {
    getFixupPrototypeFunction() { return ZabbixHostConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ZabbixHostConfiguration>): ZabbixHostConfiguration {
        let obj = Object.assign(new ZabbixHostConfiguration(), model);
        ZabbixHostConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixHostConfiguration>): ZabbixHostConfiguration {
        if (!model) return null;
        return ZabbixHostConfiguration.newInstance(<ZabbixHostConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixHostConfiguration) {
        if (!obj) return;

        models.ZabbixHostConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixHostConfiguration): boolean {
        if (models.ZabbixConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ZabbixHostConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.items) {
            for (let val of this.items) {
                models.ZabbixElement.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the host group
     */
    host_group_id: string;

    /**
     * Name of the host group
     */
    name: string;

    /**
     * List of hosts
     */
    hosts: Array<string>;

    items: Array<models.ZabbixElement>;

}
